import React, { useEffect, useState } from "react";
import api from "../api/axios";

const GAP = 24;

const BrandsSection = () => {
  const [brands, setBrands] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(6);
  const [cardWidth, setCardWidth] = useState(200);

  /* ===== RESPONSIVE SETTINGS ===== */
  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;

      if (w < 576) {
        setVisibleCount(1);
        setCardWidth(160);
      } else if (w < 768) {
        setVisibleCount(2);
        setCardWidth(170);
      } else if (w < 1024) {
        setVisibleCount(3);
        setCardWidth(180);
      } else if (w < 1280) {
        setVisibleCount(4);
        setCardWidth(190);
      } else {
        setVisibleCount(6);
        setCardWidth(200);
      }

      setActiveIndex(0);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ===== FETCH BRANDS ===== */
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const res = await api.get("companyblog/brands/");
        setBrands(res.data.data);
      } catch (err) {
        console.error("Failed to load brands", err);
      }
    };
    fetchBrands();
  }, []);

  if (!brands.length) return null;

  const maxIndex = Math.max(brands.length - visibleCount, 0);

  return (
    <>
      <style>{`
        /* ===== SECTION ===== */
        .brands-section {
          padding: 70px 0;
          background: #ffffff;
          text-align: center;
        }

        .carousel-wrapper {
          position: relative;
          max-width: 1300px;
          margin: 40px auto 0;
          padding: 0 60px;
        }

        /* ===== CAROUSEL ===== */
        .brand_carousel {
          overflow: hidden;
        }

        .track {
          display: flex;
          gap: ${GAP}px;
          transition: transform 0.45s ease;
          transform: translateX(-${activeIndex * (cardWidth + GAP)}px);
        }

        /* ===== BRAND CARD ===== */
        .brand-card {
          min-width: ${cardWidth}px;
          height: 120px;
          background: #ffffff;
          border-radius: 12px;
          box-shadow: 0 8px 25px rgba(0,0,0,0.06);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .brand-card img {
          max-width: 120px;
          max-height: 60px;
          object-fit: contain;
        }

        /* ===== ARROWS (ALWAYS VISIBLE) ===== */
        .arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 42px;
          height: 42px;
          border-radius: 50%;
          background: #ffffff;
          border: none;
          box-shadow: 0 6px 20px rgba(0,0,0,0.15);
          cursor: pointer;
          font-size: 22px;
          z-index: 10;
        }

        .arrow.left { left: 10px; }
        .arrow.right { right: 10px; }

        .arrow:disabled {
          opacity: 0.35;
          cursor: not-allowed;
        }

        /* ===== MOBILE ===== */
        @media (max-width: 576px) {
          .carousel-wrapper {
            padding: 0 15px;
          }

          .arrow {
            width: 36px;
            height: 36px;
            font-size: 18px;
          }

          .brand-card {
            height: 100px;
          }
        }

        /* ===== TABLET ===== */
        @media (max-width: 1024px) {
          .carousel-wrapper {
            padding: 0 40px;
          }
        }
      `}</style>

      <section className="brands-section">
        <div className="section-title-five">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="content">
                  <h6>Our Brands</h6>
                  <h2 className="fw-bold">Our Authorized Brands</h2>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="carousel-wrapper">
          <button
            className="arrow left"
            onClick={() => setActiveIndex((i) => Math.max(i - 1, 0))}
            disabled={activeIndex === 0}
          >
            ‹
          </button>

          <div className="brand_carousel">
            <div className="track">
              {brands.map((brand) => (
                <div className="brand-card" key={brand.id}>
                  <img src={brand.logo} alt={brand.name} />
                </div>
              ))}
            </div>
          </div>

          <button
            className="arrow right"
            onClick={() =>
              setActiveIndex((i) => Math.min(i + 1, maxIndex))
            }
            disabled={activeIndex === maxIndex}
          >
            ›
          </button>
        </div>
      </section>
    </>
  );
};

export default BrandsSection;


